// extracted by mini-css-extract-plugin
export default {"mainContent":"HomePage_mainContent__6QW7R"};